/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import { dynamicGlassCataloguesPDF } from "../../../redux/homeSlice";
import { AppDispatch } from "../../../redux/store";
import InnerBannerWrapper from "./innerBannerWrapper";

function CatalogueInner() {
  const location = useLocation();
  const navigate = useNavigate();
  // const subCategoryID: string = location?.state?.subCategoryId || "";
  // const subCategoryName: string = location?.state?.subCategoryName || "";

  const params = new URLSearchParams(location.search);

  const subCategoryID: string = params.get('subCategoryId') || "";
  const subCategoryName: string = params.get('subCategoryName') || "";

  if (subCategoryID === "" || subCategoryName === "") {
    navigate('/');
  }

  const dispatch = useDispatch<AppDispatch>();
  const { glassCataloguesPDF, loadingPDF } = useSelector(
    (state: any) => state.home
  );

  useEffect(() => {
    dispatch(dynamicGlassCataloguesPDF(subCategoryID));
  }, []);
  return (
    <>
      <InnerBannerWrapper />

      <Loader isLoading={loadingPDF} />

      <section className="cataloguesInner py-100">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-12 text-center mb-5">
              <h2 className="titleMain">DOWNLOAD CATALOGUES</h2>
              <p className="txt-gray">
                View or download the catalogues that help you open the world of
                sophistication, and discover the perfect engineering to make
                your vision a reality.
              </p>
            </div>
            <div className="col-lg-10 col-md-10 col-sm-12 col-12">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="cataloguesDownImg">
                    <div className="jbLogoHldr">
                      <img src="assets/images/logo.webp" alt=" " />
                    </div>
                    <div className="pdfImgTitleHldr">
                      <div className="pdfImgHldr">
                        <img src="assets/images/pdf-img.webp" alt=" " />
                      </div>
                      <div className="pdfTitle">{subCategoryName}</div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center">
                  <div className="cataDownTxtHldr">
                    <h2>{subCategoryName}</h2>

                    <div className="d-flex mt-4">
                      {/* <a
                       
                          className="btn btn-black-border1 me-3"
                          target="_blank"
                        >
                          View
                        </a>                */}
                      {loadingPDF ? (
                        <a className="btn btn-black-border1" target="_blank">
                          Loading
                        </a>
                      ) : (
                        <a
                          href={glassCataloguesPDF?.AWSFilePath}
                          className="btn btn-black-border1"
                          target="_blank" rel="noreferrer"
                        >
                          Download
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CatalogueInner;
